export default __webpack_public_path__ + "static/media/OIDC_New_Application.963aa12c.png";